import { Skeleton } from "@/components/ui/skeleton";

const MenuItemSkeleton = () => {
  return (
    <div className="mx-5 flex w-56 items-center gap-4">
      <Skeleton className="aspect-square h-5 rounded-sm" />
      <Skeleton className="h-5 w-full rounded-sm" />
    </div>
  );
};

export const MenusSkeleton = () => {
  return (
    // <div className="my-10 grid grid-cols-3 items-center justify-start gap-x-4 gap-y-6 rounded sm:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-9">
    <div className="mt-10 hidden flex-col flex-wrap gap-10 md:flex">
      {Array.from({ length: 10 }).map((_, i) => (
        <MenuItemSkeleton key={i} />
      ))}
    </div>
  );
};
